export default [
    {
        title: 'Документация',
        icon: 'BookOpenIcon',
        route: 'documentation-list',
        action: 'read',
        resource: 'common',
    },
]
